module.exports = __webpack_public_path__ + "img/windows3.f890f24a.jpg";